import { atom } from 'recoil';

const warrantyInput = atom({
  key: 'warrantyInput',
  default: {
    firstName: '',
    lastName: '',
    email: '',
    serialNumber: '',
    orderId: undefined,
    source: ''
  }
});

export default warrantyInput;
